import {
  SortDirectionEnum,
  UlohaListItem,
  UlohaListPage,
  UlohyOrganizacieDetailApi,
} from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import LegislativnyMaterialUlohaListPage
  from '../../model/legislativnyMaterial/ulohy/LegislativnyMaterialUlohaListPage';
import LegislativnyMaterialUlohaItem
  from '../../model/legislativnyMaterial/ulohy/LegislativnyMaterialUlohaItem';
import { mapStadium } from '../../model/legislativnyMaterial/StadiumMaterialu';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import { mapPracovnyKrok } from '../pracovnyKrok/pracovnyKrokListClient';

const client = new UlohyOrganizacieDetailApi(apiConfiguration(elegislativaPrefixPath));

const mapMaterial = (data: UlohaListItem): LegislativnyMaterialUlohaItem => ({
  cisloLp: data.cisloLegislativnehoMaterialu,
  nazov: data.nazov,
  stadium: mapStadium(data.stadium),
  uuid: data.uuid,
  typ: data.typ,
  datumPrijatia: data.datumPrijatia ? new Date(data.datumPrijatia) : undefined,
  datumVybavenia: data.datumVybavenia ? new Date(data.datumVybavenia) : undefined,
  pracovneKroky: data.pracovnyKrokList?.map(pracovnyKrok => mapPracovnyKrok(pracovnyKrok)),
});

const map = (data: UlohaListPage): LegislativnyMaterialUlohaListPage => ({
  materialList: data.legMaterialList.map(material => mapMaterial(material)),
  number: data.number,
  size: data.size,
  totalElements: data.totalElements,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchUlohyOrganizacieDetailPage = async (
  uuid: string,
  page?: number,
  size?: number,
  sortBy?: string,
  sortDirection?: SortDirectionEnum,
  searchText?: string,
  headers?: object,
):
  Promise<ClientResponse<LegislativnyMaterialUlohaListPage>> => {
  const {
    data,
    status,
  } = await client.getUlohyOrganizacieDetail(uuid, searchText, page, size, sortBy, sortDirection, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
